/**
 * Source Health page — /sources/health
 *
 * Standalone page (no tabs). Shows health stats across all data sources.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { HeartPulse } from 'lucide-react';
import { useUser } from '@/hooks/useUser';
import { SourceHealthDashboard } from '@/components/admin/SourceHealthDashboard';
import { usePageTitle } from '@/hooks/usePageTitle';

export const SourceHealthPage: React.FC = () => {
  usePageTitle('Source Health');
  const { user } = useUser();

  const canManage = user && user.role === 'SYSTEM_ADMIN';

  if (user && !canManage) return <Navigate to="/dashboard" replace />;

  return (
    <div className="space-y-6">
      {/* ── Header ── */}
      <div>
        <div className="flex items-center gap-2 mb-1">
          <HeartPulse className="w-7 h-7 text-emerald-600" />
          <h1 className="text-3xl font-bold text-gray-900">Source Health</h1>
        </div>
        <p className="text-gray-500">
          Worker status, searchable artifact coverage, and stuck-artifact
          diagnostics across all jurisdictions.
        </p>
      </div>

      {/* ── Dashboard ── */}
      <SourceHealthDashboard />
    </div>
  );
};
